define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory",
	"csi/xml"
], function(Button,_Plugin,PluginFactory,xml) {

	return PluginFactory.declare([Button, _Plugin], {
		materialIcon: "undo",
		pluginName: "undo",
		title: "CanvasUndo",

		/**
		 * Only enable when in default mode and there are operations to undo
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			return this.editor.isUndoAllowed();
		},

		/**
		 * Undo click event
		 * @param {Event} e
		 */
		onClick: function(e) {
			this.editor.undo();
		}
	});
});
